import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PAGE_NAMES = {
  "/Empresarial": "Empresarial",
  "/Empaquetarout": "Agregar servicios",
  "/valoin": "Cobertura",
  "/planes": "Comprar",
  "/Login": "Ingresar",
  "/Intpersonas": "Servicios - Internet",
  "/tvpersonas": "Servicios - Televisión",
  "/Telefoniapersonas": "Servicios - Telefonía",
};

export function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "virtualPageView",
      pagePath: location.pathname,
      pageName: PAGE_NAMES[location.pathname] || location.pathname,
    });
  }, [location.pathname]);

  return null;
}
